<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.employee.attendanceShift.shift') }}
      </h1>
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-8">
            <ts-button v-if="!is_hris" color="info" outline @click="$router.push({ name: 'attendance-shift-create' })">
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end"></div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading" :expandable="true">
        <template v-slot="{ record }">
          <td>{{ record.shift_name }}</td>
          <td>{{ record.shift_type }}</td>
          <td class="text-center">{{ record.minute_allow }}</td>
          <td class="text-center">
            <span class="badge badge-success" v-if="!record.inactive">{{
              $t('yes')
            }}</span>
            <span class="badge badge-default" v-else>{{ $t('no') }}</span>
          </td>
          <td class="text-center">
            <a href="#" v-tooltip="$t('tooltip.edit')" class="mr-2 text-primary" @click.prevent="edit(record)"
              v-if="!is_hris">
              <i class="fas fa-edit"></i>
            </a>
            <a href="#" v-tooltip="$t('tooltip.delete')" class="text-danger" @click.prevent="destroy(record)"
              :disabled="record._deleting" v-if="!is_hris">
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-else></i>
            </a>
          </td>
        </template>
        <div slot="expand" slot-scope="prop">
          <table class="ts-w-full ts-mx-auto detail">
            <thead>
              <tr class="ts-uppercase ts-bg-gray-200 ts-h-8 ts-text-white">
                <th style="width: 10%">
                  {{ $t('administration.employee.attendanceShift.keyword') }}
                </th>
                <th>
                  {{ $t('administration.employee.attendanceShift.fromDay') }}
                </th>
                <th>
                  {{ $t('administration.employee.attendanceShift.toDay') }}
                </th>
                <th style="width: 12%">
                  {{ $t('administration.employee.attendanceShift.firstIn') }}
                </th>
                <th style="width: 12%">
                  {{ $t('administration.employee.attendanceShift.firstOut') }}
                </th>
                <th style="width: 12%">
                  {{ $t('administration.employee.attendanceShift.secondIn') }}
                </th>
                <th style="width: 12%">
                  {{ $t('administration.employee.attendanceShift.secondOut') }}
                </th>
                <th style="width: 12%">
                  {{ $t('administration.employee.attendanceShift.thirdIn') }}
                </th>
                <th style="width: 12%">
                  {{ $t('administration.employee.attendanceShift.thirdOut') }}
                </th>
                <th style="width: 20%">
                  {{ $t('administration.employee.attendanceShift.TotalHours') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="ts-border-b-2" v-for="(detail, index) in prop.record.details" :key="index">
                <td>
                  {{ detail.keyword }}
                </td>
                <td>
                  {{ detail.from_day }}
                </td>
                <td>
                  {{ detail.to_day }}
                </td>
                <td>
                  {{ tConvert(detail.first_in) }}
                </td>
                <td>
                  {{ tConvert(detail.first_out) }}
                </td>
                <td>
                  {{ tConvert(detail.second_in) }}
                </td>
                <td>
                  {{ tConvert(detail.second_out) }}
                </td>
                <td>
                  {{ tConvert(detail.third_in) }}
                </td>
                <td>
                  {{ tConvert(detail.third_out) }}
                </td>
                <td>
                  {{ totalHour(detail).description }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'attendance-shift',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('attendanceShift', ['resources', 'pagination', 'weekDays']),
    ...mapGetters('attendanceShift', ['totalHour', 'tConvert']),
    search: {
      get() {
        return this.$store.state.attendanceShift.search
      },
      set(newValue) {
        this.$store.commit('attendanceShift/SET_SEARCH', newValue)
        this.$store.commit('attendanceShift/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('administration.employee.attendanceShift.shiftName')
        },
        {
          name: this.$t('administration.employee.attendanceShift.shiftType'),
          style: 'width:20%'
        },
        {
          name: this.$t('administration.employee.attendanceShift.minuteAllow'),
          style: 'text-align:center; width:10%'
        },
        {
          name: this.$t('administration.employee.attendanceShift.active'),
          style: 'text-align:center; width:10%'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width:7%'
        }
      ]
    },
    is_hris() {
      if (this.$store.state.authUser.company) {
        return this.$store.state.authUser.company.is_hris
      }
      return false
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('attendanceShift/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('attendanceShift/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'attendance-shift-edit',
        params: { id: record.shift_id }
      })
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('attendanceShift/destroy', record.shift_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'attendance-shift-create') {
      this.$store.commit('attendanceShift/RESET_STATE')
      this.$store.commit('attendanceShift/SET_WEEK_DAYS', [])
    }
    next()
  }
}
</script>
